<template >
  <div class="text-xs-center">
    <v-menu v-model="menu" :close-on-content-click="true" offset-y="offset-y">
      <template v-slot:activator="{ on }">
        <v-card class="pl-3 pr-2" v-on="on" v-if="$vuetify.breakpoint.smAndUp">
          <span class="body-2 font-weight-light mr-3">{{
            currentUser.fullName
          }}</span>
          <v-avatar size="25px">
            <img
              v-if="currentUser.imageUrl"
              :src="currentUser.imageUrl"
              alt="User"
            />
            <img v-else src="../../../assets/images/user.jpeg" alt="User" />
          </v-avatar>
        </v-card>
        <v-btn
          v-on="on"
          icon="icon"
          large="large"
          v-if="$vuetify.breakpoint.xsOnly"
        >
          <v-avatar size="40px">
            <img
              v-if="currentUser.imageUrl"
              :src="currentUser.imageUrl"
              alt="User"
            />
            <img v-else src="../../../assets/images/user.jpeg" alt="User" />
          </v-avatar>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              <v-layout>
                <img
                  class="menu-img"
                  v-if="currentUser.imageUrl"
                  :src="currentUser.imageUrl"
                  alt="User"
                />
                <img
                  class="menu-img"
                  v-else
                  src="../../../assets/images/user.jpeg"
                  alt="User"
                />
                <v-flex class="ml-2">
                  <v-list-tile-title>{{currentUser.fullName}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{currentUser.AccountType.accountTypeName}}</v-list-tile-sub-title>
                </v-flex>
              </v-layout>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                small="small"
                color="pink"
                dark="dark"
                icon="icon"
                @click="editProfile"
              >
                <v-icon small="small">edit</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-divider> </v-divider>
        <v-list>
          <v-list-tile>
            <v-list-tile-title>
              <v-layout>
                <span>Your Rating</span>
                <v-spacer> </v-spacer>
                <v-rating
                  v-model="rating"
                  dense="dense"
                  readonly="readonly"
                  half-increments="half-increments"
                  hover="hover"
                >
                </v-rating>
              </v-layout>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn color="primary" flat="flat" to="/logout">{{
            $t("buttons.logout")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import menuService from '../service.js';

export default {
  name: 'layout-menu',
  data() {
    return {
      rating: 0,
      fav: true,
      menu: false,
      message: false,
      hints: true,
    };
  },
  mounted() {
    this.getRating();
  },
  computed: {
    ...mapGetters('global', ['currentUser']),
  },
  methods: {
    editProfile() {
      this.$router.push(`/user/edit/${this.currentUser.userID}`);
    },
    getRating() {
      menuService.getRating(this.currentUser.userID).then((result) => {
        this.rating = result.data[0].average;
      });
    },
  },
};
</script>

<style scoped>
.menu-box {
  border: white solid 0.1em;
  padding: 7px;
  border-radius: 4px;
  cursor: pointer;
}
.menu-img {
  border-radius: 4px;
  width: 45px;
  height: 48px;
}
</style>
